<div class="text-center pt-5">
  <h1 class="mb-0">404</h1>
  <p>page not found :(</p>
</div>
